import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TitanButtonComponent } from 'src/app/user-interface/titan-button/titan-button.component';
import { TitanIconComponent } from 'src/app/user-interface/titan-icon/titan-icon.component';
import { TitanPillComponent } from 'src/app/user-interface/titan-pill/titan-pill.component';
import { NgIf, NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-sp-card-selector',
  templateUrl: './sp-card-selector.component.html',
  styleUrls: ['./sp-card-selector.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    TitanButtonComponent,
    TitanIconComponent,
    TitanPillComponent,
    MatTooltipModule
  ]
})
export class SpCardSelectorComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() iconVariant?: string;
  @Input() iconClass?: string;
  @Input() imageUrl?: string;
  @Input() buttonVariant: 'primary' | 'secondary' = 'secondary';
  @Input() buttonText = 'Start your analysis';
  @Input() disabled = false;
  @Input() showButton = true;
  @Input() badge?: string;
  @Input() minWidth = '250px';

  @Output() cardClick = new EventEmitter<void>();

  onCardClick() {
    if (!this.disabled) {
      this.cardClick.emit();
    }
  }
}
